import dayjs from 'dayjs';
import { t } from 'i18next';
import { object, string, type z } from 'zod';
import { passwordMaxLength, passwordMinLength } from '@/constants/generic';

export const signInSchema = object({
  identifier: string().min(1, t('validate.email.required')).email(t('validate.email.invalid')),
  password: string()
    .min(1, t('validate.password.required'))
    .min(passwordMinLength, t('validate.password.min', { min: passwordMinLength }))
    .max(passwordMaxLength, t('validate.password.max', { max: passwordMaxLength })),
});

export const currentUserSchema = object({
  firstName: string()
    .min(1, 'Vorname ist erforderlich')
    .max(50, 'Vorname darf maximal 50 Zeichen lang sein'),
  lastName: string()
    .min(1, 'Nachname ist erforderlich')
    .max(50, 'Nachname darf maximal 50 Zeichen lang sein'),
  birthDate: string()
    .min(1, 'Geburtsdatum ist erforderlich')
    .max(10, 'Geburtsdatum hat ein ungültiges Format')
    .refine(
      (date) => {
        const parsed = dayjs(date, 'YYYY-MM-DD');
        return parsed.isValid() && parsed.isAfter('1900-01-01') && parsed.isBefore(dayjs());
      },
      { message: 'Bitte geben Sie ein gültiges Geburtsdatum ein' },
    ),
  address: object({
    street: string()
      .min(1, 'Straße und Hausnummer sind erforderlich')
      .max(100, 'Straße und Hausnummer dürfen maximal 100 Zeichen lang sein'),
    zipCode: string().regex(/^\d{5}$/, 'PLZ muss aus genau 5 Ziffern bestehen'),
    city: string()
      .min(1, 'Stadt ist erforderlich')
      .max(100, 'Stadt darf maximal 100 Zeichen lang sein'),
    country: string()
      .min(1, 'Land ist erforderlich')
      .max(100, 'Land darf maximal 100 Zeichen lang sein'),
  }),
});

export type CurrentUserForm = z.infer<typeof currentUserSchema>;
